import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { User, Lock, Loader2, ArrowLeft, Eye, EyeOff } from "lucide-react";
import { usePanel } from "../context";
import { apiErr } from "../api";
import { BRAND } from "../brand";
import { PanelPage, BrandLogo } from "../ui";

export default function Login() {
  const { user, login } = usePanel();
  const nav = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [show, setShow] = useState(false);
  const [busy, setBusy] = useState(false);

  useEffect(() => { if (user) nav("/dashboard", { replace: true }); }, [user, nav]);

  const submit = async (e) => {
    e.preventDefault();
    if (!username || !password) { toast.error("Escribe tu usuario y contraseña"); return; }
    setBusy(true);
    try { await login(username, password); nav("/dashboard", { replace: true }); }
    catch (err) { toast.error(apiErr(err, "No se pudo ingresar")); }
    finally { setBusy(false); }
  };

  return (
    <PanelPage>
      <div className="min-h-screen flex flex-col" style={{ background: "radial-gradient(900px 500px at 50% 0%, color-mix(in srgb, var(--accent) 14%, transparent), transparent 60%), var(--page)" }}>
        <div className="max-w-6xl w-full mx-auto px-5 h-[72px] flex items-center justify-between">
          <Link to="/"><BrandLogo /></Link>
          <Link to="/" className="text-sm pn-sub inline-flex items-center gap-1.5"><ArrowLeft size={15} /> Volver al sitio</Link>
        </div>
        <div className="flex-1 flex items-center justify-center px-5 py-10">
          <form onSubmit={submit} className="pn-card pn-fade rounded-3xl w-full max-w-md p-8 sm:p-10">
            <p className="text-[11px] font-bold uppercase tracking-[0.25em] pn-brand mb-2">Acceso clínico</p>
            <h1 className="text-2xl font-bold pn-ink mb-1">{BRAND.doctor}</h1>
            <p className="pn-sub text-sm mb-7">Panel de pacientes, agenda y casos.</p>
            <label className="pn-label">Usuario</label>
            <div className="relative mb-4">
              <User size={16} className="absolute left-3 top-1/2 -translate-y-1/2 pn-muted" />
              <input autoFocus autoComplete="username" value={username} onChange={(e) => setUsername(e.target.value)} className="pn-field !pl-9" />
            </div>
            <label className="pn-label">Contraseña</label>
            <div className="relative mb-7">
              <Lock size={16} className="absolute left-3 top-1/2 -translate-y-1/2 pn-muted" />
              <input type={show ? "text" : "password"} autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)} className="pn-field !pl-9 !pr-10" />
              <button type="button" onClick={() => setShow((s) => !s)} className="absolute right-3 top-1/2 -translate-y-1/2 pn-muted" aria-label={show ? "Ocultar contraseña" : "Mostrar contraseña"}>
                {show ? <EyeOff size={16} /> : <Eye size={16} />}
              </button>
            </div>
            <button type="submit" disabled={busy} className="pn-btn pn-btn-primary w-full py-3 uppercase tracking-wide">
              {busy ? <><Loader2 size={18} className="pn-spin" /> Ingresando…</> : "Ingresar"}
            </button>
            <p className="text-[11px] pn-muted text-center mt-4">El primer ingreso del día puede tardar unos segundos mientras el servidor despierta.</p>
          </form>
        </div>
      </div>
    </PanelPage>
  );
}
